(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var track = document.querySelector('.about-carousel__track');
    var slides = document.querySelectorAll('.about-carousel__slide');
    var dots = document.querySelectorAll('.about-carousel__dot');
    var prevBtn = document.querySelector('.about-carousel__arrow--prev');
    var nextBtn = document.querySelector('.about-carousel__arrow--next');
    if (!track || slides.length < 2) return;

    var current = 0;
    var timer = null;
    var interval = 30000;

    function goTo(index) {
      current = index;
      track.style.transform = 'translateX(-' + (100 * current) + '%)';
      dots.forEach(function(dot, i) {
        dot.classList.toggle('about-carousel__dot--active', i === current);
      });
      resetTimer();
    }

    function nextSlide() {
      goTo((current + 1) % slides.length);
    }

    function resetTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(nextSlide, interval);
    }

    prevBtn.addEventListener('click', function () {
      goTo(current === 0 ? slides.length - 1 : current - 1);
    });

    nextBtn.addEventListener('click', function () {
      goTo(current === slides.length - 1 ? 0 : current + 1);
    });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    resetTimer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured"] && !Shopify.designMode) return;
  try {
    
  // Infinite-looping featured products carousel
  document.addEventListener('DOMContentLoaded', function() {
    var carousel = document.querySelector('.featured-products__carousel');
    if (!carousel) return;
    var interval = 10000;

    function getCardWidth() {
      var firstCard = carousel.children[0];
      if (!firstCard) return 0;
      var style = getComputedStyle(carousel);
      var gap = parseInt(style.gap || 0);
      return firstCard.offsetWidth + gap;
    }

    function scrollNext() {
      var cardWidth = getCardWidth();
      carousel.scrollBy({ left: cardWidth, behavior: 'smooth' });
      setTimeout(function() {
        // If the first card is fully out of view, move it to the end
        var firstCard = carousel.children[0];
        var carouselRect = carousel.getBoundingClientRect();
        var cardRect = firstCard.getBoundingClientRect();
        if (cardRect.right <= carouselRect.left + 1) {
          carousel.appendChild(firstCard);
          // Instantly reset scroll position to show the next card seamlessly
          carousel.scrollLeft -= cardWidth;
        }
      }, 400); // Wait for smooth scroll to finish
    }

    setInterval(scrollNext, interval);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Thumbnail switcher
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var mainImg = document.getElementById('product-main-image');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.dataset.src;
        thumbs.forEach(function (t) { t.classList.remove('product-gallery__thumb--active'); });
        thumb.classList.add('product-gallery__thumb--active');
      });
    });

    // Quantity stepper
    var minusBtn = document.getElementById('qty-minus');
    var plusBtn = document.getElementById('qty-plus');
    var qtyInput = document.getElementById('product-quantity');

    if (minusBtn && plusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });
      plusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10);
        qtyInput.value = val + 1;
      });
    }

    // Update displayed price when the selected variant changes
var variantSelect = document.getElementById('product-variant');
var priceContainer = document.getElementById('product-price');

function formatMoney(cents) {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD'
  }).format(cents / 100);
}

if (variantSelect && priceContainer) {
  variantSelect.addEventListener('change', function () {
    var selectedOption = this.options[this.selectedIndex];
    var price = Number(selectedOption.dataset.price || 0);
    var comparePrice = Number(selectedOption.dataset.comparePrice || 0);

    if (comparePrice > price) {
      priceContainer.innerHTML =
        '<span class="product-info__price--compare">' +
          formatMoney(comparePrice) +
        '</span>' +
        '<span class="product-info__price--sale">' +
          formatMoney(price) +
        '</span>';
    } else {
      priceContainer.innerHTML =
        '<span class="product-info__price--regular">' +
          formatMoney(price) +
        '</span>';
    }
  });
}
  });



  } catch(e) { console.error(e); }
})();
})();
